import { registerModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import TransportPackage from './TransportPackage';
import '@sas-dvr/ltjs-gtl/lib';
registerModule('transport', [TransportPackage]);
